<template>
	<inline-svg :src="require(`@/assets/img/pbi/${name}.svg`)" />
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
	name: "PBIcons",
	components: {
		InlineSvg,
	},
	props: {
		name: {
			type: String,
		},
	},
	data: () => ({}),
	methods: {},
};
</script>
